import { useEffect, useState } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { SILENCE_WARNING_DELAY } from '@/entities/session';
import { metronome } from '@/shared/lib/metronome';

import { useRecordingStore } from './recording-store';

type UseSilenceDetectionReturn = {
    detectSilence: (isAudioLevelLow: boolean) => void;
};

export function useSilenceDetection(): UseSilenceDetectionReturn {
    const [isAudioLevelLow, setIsAudioLevelLow] = useState(false);

    const { status, setIsSilent } = useRecordingStore(
        useShallow((state) => ({
            status: state.status,
            setIsSilent: state.setIsSilent,
        })),
    );

    useEffect(() => {
        let destroySilenceMetronome: () => void;

        if (status === 'recording' && isAudioLevelLow) {
            destroySilenceMetronome = metronome(
                () => {
                    setIsSilent(true);
                },
                SILENCE_WARNING_DELAY,
                { tickOnce: true },
            );
        } else {
            setIsSilent(false);
        }

        return () => {
            destroySilenceMetronome?.();
        };
    }, [isAudioLevelLow, status, setIsSilent]);

    return {
        detectSilence: setIsAudioLevelLow,
    };
}
